import { z } from 'zod'

// Paramètres d'URL du configurateur industriel, sans dépendance à la page : la route les évalue
// d'emblée, hors du découpage du code (la page et ses panneaux restent dans leur chunk).

export const CONFIGURATOR_TAB_VALUES = ['kitchens', 'zones', 'references'] as const
export type ConfiguratorTab = (typeof CONFIGURATOR_TAB_VALUES)[number]

/**
 * Onglet porté par l'URL : un lien peut ouvrir directement « Zones » (avertissement du simulateur
 * logistique pour un atelier sans zone de parc). Valeur inconnue : l'onglet par défaut.
 */
export const industrialConfiguratorSearchSchema = z.object({
  tab: z.enum(CONFIGURATOR_TAB_VALUES).optional().catch(undefined),
})
